import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaPagamentoRecorrente = (): TabelaColuna => ({
  Chave: 'PagamentoRecorrente',
  ComOrdenacao: true,
  RenderizarCabecalho: () => (
    <div style={{ width: 250 }}>Pagamento Recorrente</div>
  )
})
